<template>
    <div id="app-bar-gsap" class="bg-white w-full border-b min-h-[56px] flex justify-between items-center px-[12px]">
        <div class="flex items-center gap-x-[8px] text-black font-extralight">
            <RouterLink to="/">Dashboard</RouterLink>
            <span>/ <RouterLink v-for="(value,idx) in getCurrentRoute" :to="value.join('/')" :key="idx" :class="{'hidden':getElement[idx].length == 0}">{{ getElement[idx] }} / </RouterLink></span>
        </div>
        <div class="flex items-center gap-6">
            <div class="h-[36px] px-6 rounded-xl text-[#2b2b2b] flex items-center border font-light">{{ getTime }}</div>
            <button class="h-[36px] px-6 rounded-xl text-[#2b2b2b] border flex items-center gap-x-[12px] justify-center font-light">
                <Languages :size="16" strokeWidth="1.3"/>
                Français
            </button>
            <clockComponent />
            <DropdownMenuRoot v-model="toggleState">
                <DropdownMenuTrigger
                    class="rounded-full h-[36px] inline-flex items-center gap-x-[6px] justify-center text-grass11 bg-white shadow-[0_2px_10px] shadow-blackA7 outline-none hover:bg-green3 focus:shadow-[0_0_0_2px] focus:shadow-black"
                    aria-label="Customise options">
                    <button class="size-[36px] rounded-full border border-[#cdd3d7]
                        flex justify-center items-center">
                        <span class="text-[#5e5e5e] font-light">
                            {{firstNameIndex}}{{lastNameIndex}}
                        </span>
                    </button>
                    <div class="flex flex-col gap-y-[0] p-[2px] items-start text-black">
                        <span class="font-light text-[13px]">{{ f_name + " " + l_name }}</span>
                        <span class="font-extralight text-[10px]">{{ profil }}</span>
                    </div>
                </DropdownMenuTrigger>
                <DropdownMenuPortal>
                    <DropdownMenuContent
                        class="min-w-[220px] text-black outline-none bg-white rounded-md p-[5px] shadow-[0px_10px_38px_-10px_rgba(22,_23,_24,_0.35),_0px_10px_20px_-15px_rgba(22,_23,_24,_0.2)] will-change-[opacity,transform] data-[side=top]:animate-slideDownAndFade data-[side=right]:animate-slideLeftAndFade data-[side=bottom]:animate-slideUpAndFade data-[side=left]:animate-slideRightAndFade"
                        :side-offset="5">
                        <DropdownMenuItem value="New Tab"
                            class="text-[14px] cursor-pointer hover:bg-[#f9fafb] leading-none rounded-md flex items-center justify-between p-4 select-none outline-none data-[disabled]:pointer-events-none"
                            v-on:click="logout"
                            >
                                <div class="flex items-center gap-x-2">
                                    <LucideLogOut :size="18" />
                                    <span>Déconnexion</span>
                                </div>
                            <div class="ml-auto pl-[20px] text-mauve11 group-data-[highlighted]:text-white">
                                ⌘+W
                            </div>
                        </DropdownMenuItem>
                    <DropdownMenuArrow class="fill-white" />
                </DropdownMenuContent>
                </DropdownMenuPortal>
            </DropdownMenuRoot>
        </div>
    </div>
</template>

<script>
import { LucideLogOut,Languages } from 'lucide-vue-next';
import Auth from "../../service/Auth.js";
import { RouterLink } from 'vue-router';
import clockComponent from '../btn/clock-component.vue';
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuRoot,
  DropdownMenuTrigger,
  DropdownMenuArrow
} from 'radix-vue'
import gsap from "gsap";
export default {
    name: 'AppBar',
    components: {
        Languages,
        clockComponent,
        // Bell,
        // MessageSquare,
        // Search,
        RouterLink,
        LucideLogOut,
        DropdownMenuContent,
        DropdownMenuItem,
        DropdownMenuPortal,
        DropdownMenuRoot,
        DropdownMenuTrigger,
        DropdownMenuArrow
    },
    data(){
        return {
            toggleState:false,
            f_name:"",
            l_name:"",
            profil:"",
        }
    },
    mounted(){
        this.f_name = this.$store.getters.firstName ?? "";
        this.l_name = this.$store.getters.lastName ?? "";
        this.profil = this.$store.getters.profil ?? "";
        gsap.set("#app-bar-gsap", {yPercent: -100});
        gsap.to("#app-bar-gsap", {
                yPercent: 0,
                duration: 0.8,
                delay: 1,
                ease: "power2.out",
            });
    },
    methods: {
        logout(){
            Auth.logout();
        },
        openProfil(){
            this.$store.dispatch("switchShowProfil",true);
        },
         convertirSegmentsEnCheminsCumulatifs(segments) {
            const cheminsCumulatifs = [];
            let cheminCourant = [];

            for (const segment of segments) {
                cheminCourant = [...cheminCourant, segment];
                cheminsCumulatifs.push([...cheminCourant]);
            }

            return cheminsCumulatifs;
        }
    },
    computed:{
        firstNameIndex(){
            return this.$store.getters.firstName?.trim().charAt(0).toUpperCase();
        },
        lastNameIndex(){
            return this.$store.getters.lastName?.trim().charAt(0).toUpperCase();
        },
        getTime(){
            return (new Date()).toDateString();
        },
        getCurrentRoute(){
            const tabPath = this.$route.fullPath.split('/');
            return this.convertirSegmentsEnCheminsCumulatifs(tabPath);
        },
        getElement(){
            return this.$route.fullPath.split('/');
        },
        getCurrentPath(){
            return this.$route.fullPath;
        }
    },
}
</script>